import { motion } from "framer-motion";

import { content } from "../content/content";
import { fadeUp } from "../hooks/useScrollReveal";

const SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/SadafalEducation",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/sadafaleducation",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/sadafal-education",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@sadafaleducation",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
];

export function Footer() {
  return (
    <footer className="bg-ink text-white/80">
      <div className="mx-auto max-w-[1400px] px-6 pt-20 pb-10 md:px-10">
        <motion.div
          className="grid gap-12 md:grid-cols-2 lg:grid-cols-4"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-6 flex items-center gap-3">
              <img src="/logo.svg" alt="" className="h-8 w-auto" />
              <span
                data-edit-id="content.footer.brand"
                className="font-display text-lg font-medium text-white"
              >
                {content.footer.brand}
              </span>
            </div>
            <p
              data-edit-id="content.footer.tagline"
              className="mb-6 text-sm leading-relaxed text-white/60"
            >
              {content.footer.tagline}
            </p>
            <div className="flex gap-4">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="text-white/40 transition-colors duration-300 hover:text-saffron"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4
              data-edit-id="content.footer.exploreHeading"
              className="mb-4 font-display text-sm font-medium tracking-widest text-white/40 uppercase"
            >
              {content.footer.exploreHeading}
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="#stories"
                  className="transition-colors hover:text-white"
                >
                  Our Stories
                </a>
              </li>
              <li>
                <a
                  href="#journey"
                  className="transition-colors hover:text-white"
                >
                  Our Journey
                </a>
              </li>
              <li>
                <a
                  href="#centers"
                  className="transition-colors hover:text-white"
                >
                  Our Centres
                </a>
              </li>
              <li>
                <a href="#team" className="transition-colors hover:text-white">
                  Who We Are
                </a>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h4
              data-edit-id="content.footer.communityHeading"
              className="mb-4 font-display text-sm font-medium tracking-widest text-white/40 uppercase"
            >
              {content.footer.communityHeading}
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="/gallery"
                  className="transition-colors hover:text-white"
                >
                  Gallery
                </a>
              </li>
              <li>
                <a href="#trust" className="transition-colors hover:text-white">
                  The Trust
                </a>
              </li>
              <li>
                <a
                  href="#newsletters"
                  className="transition-colors hover:text-white"
                >
                  Newsletters
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/watch?v=ly8jO2hA-Gg"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-white"
                >
                  Watch the Documentary
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4
              data-edit-id="content.footer.connectHeading"
              className="mb-4 font-display text-sm font-medium tracking-widest text-white/40 uppercase"
            >
              {content.footer.connectHeading}
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="#contact"
                  className="transition-colors hover:text-white"
                >
                  Get in Touch
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${content.footer.generalEmail}`}
                  className="block transition-colors hover:text-white"
                >
                  <span
                    data-edit-id="content.footer.generalEmailLabel"
                    className="block text-[10px] font-medium tracking-[0.18em] text-white/30 uppercase"
                  >
                    {content.footer.generalEmailLabel}
                  </span>
                  <span data-edit-id="content.footer.generalEmail">
                    {content.footer.generalEmail}
                  </span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${content.footer.trustEmail}`}
                  className="block transition-colors hover:text-white"
                >
                  <span
                    data-edit-id="content.footer.trustEmailLabel"
                    className="block text-[10px] font-medium tracking-[0.18em] text-white/30 uppercase"
                  >
                    {content.footer.trustEmailLabel}
                  </span>
                  <span data-edit-id="content.footer.trustEmail">
                    {content.footer.trustEmail}
                  </span>
                </a>
              </li>
              <li
                data-edit-id="content.footer.locations"
                className="pt-1 text-xs text-white/40"
              >
                {content.footer.locations}
              </li>
            </ul>
          </div>
        </motion.div>

        {/* Divider + copyright */}
        <div className="mt-16 border-t border-white/10 pt-8 text-center text-xs text-white/30">
          <p>
            &copy; {new Date().getFullYear()}{" "}
            <span data-edit-id="content.footer.copyrightLine">
              {content.footer.copyrightLine}
            </span>
          </p>
          <p data-edit-id="content.footer.signoff" className="mt-1 italic">
            {content.footer.signoff}
          </p>
        </div>
      </div>
    </footer>
  );
}
